export type DeploymentEnvironment = 'local' | 'staging' | 'production';

/** Build-time and runtime metadata share an explicit deployment identity. */
export function deploymentIdentity(environment: string, siteName: string) {
  if (!['local', 'staging', 'production'].includes(environment)) {
    throw new Error(`Invalid VITE_DEPLOY_ENV: ${environment}`);
  }
  const isTest = environment !== 'production';
  const name = siteName.replace(/^\[TEST\]\s*/, '');
  return {
    environment: environment as DeploymentEnvironment,
    isTest,
    title: isTest ? `[TEST] ${name}` : name,
    robots: isTest ? 'noindex, nofollow' : undefined,
    label: isTest ? `測試環境 ${environment.toUpperCase()} — 此環境資料不具效力` : '',
  };
}
